import { CommonUtilsService } from 'util/services/commonUtilsService';
import { MenuFactory } from 'sharebase/factories'
import { 
	ContextMenuItem,
	IMenuItem,
	MenuItemContext,
	DualMenuItem,
	NestedMenuItem
} from 'sharebase/domain';

export class MenuItemFactory {
	static readonly $inject = [
		'utils',
		'$q',
		'$injector'
	];

	private readonly NullMenuItem:IMenuItem = Object.freeze({
		action: 'NULL',
		label: 'Null',
		icon: '',
		trigger: angular.noop,
		visible: false,
		addValidator: () => angular.noop,
		addTrigger: () => angular.noop,
		removeAllValidators: () => this.NullMenuItem,
		removeAllTriggers: () => this.NullMenuItem,
		addMiddleware: (middlware) => angular.noop,
		removeAllMiddleware:() => this.NullMenuItem,
		canShow: () => this.$q.resolve(false),
		hasValidators: false,
		context: MenuItemContext.None,
		clone: () =>  this.NullMenuItem
	});

	constructor(
		private utils:CommonUtilsService, 
		private $q:ng.IQService,
		private $injector:ng.auto.IInjectorService
	) {
	}

	public create(action:string, label:string, icon:string):IMenuItem {
		return new ContextMenuItem(this.utils, this.$q, action, label, icon);
	}

	public createDual(action:string, item1:IMenuItem, item2:IMenuItem){
		return new DualMenuItem(this.utils, this.$q, action, item1, item2);
	}

	public createNested(action:string, label:string, icon:string){
		return new NestedMenuItem(
			this.utils, 
			this.$q, 
			// we need to use the injector to avoid circular dependency issues
			this.$injector.get('sbMenuFactory') as MenuFactory, 
			action, 
			label, 
			icon
		);
	}

	public createNull(){
		return this.NullMenuItem;
	}
}


// WEBPACK FOOTER //
// ./src/sharebase/factories/menuItemFactory.ts